<template>
  <a-card :title="params.formTitle">
    <div class="formContainer">
      <a-form :form="form" :layout="formLayout" @submit="handleSubmit">
        <a-row :gutter="8">
          <a-col :span="12">
            <a-form-item label="父菜单" :label-col="{ span: 8 }" :wrapper-col="{ span:16 }">
              <a-input
                disabled
                autocomplete="off"
                v-decorator="['pName', { rules: [{ required: true, message: '请输入父菜单!' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="key" :label-col="{ span: 8 }" :wrapper-col="{ span: 16}" hasFeedback>
              <a-input
                :disabled="!isAdmin"
                autocomplete="off"
                v-decorator="['key', { rules: [{ required: true, message: '请输入关键字!'},{pattern: /^[^\s]*$/, message: '关键字不能包含空格！' },{max:50,message:'最多输入50个字'}] }]"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="8">
          <a-col :span="12">
            <a-form-item label="名称" :label-col="{ span: 8 }" :wrapper-col="{ span: 16}" hasFeedback>
              <a-input
                autocomplete="off"
                v-decorator="['title', { rules: [{ required: true, message: '请输入菜单名称!' },{pattern: /^[^\s]*$/, message: '名称不能包含空格！' },{max:50,message:'最多输入50个字'}] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="icon" :label-col="{ span: 8 }" :wrapper-col="{ span:16}">
              <a-input
                :disabled="!isAdmin"
                autocomplete="off"
                v-decorator="['icon',{rules:[{ required: false, message: '请输入图标！' }, {pattern: /^[^\s]*$/, message: '图标不能包含空格！' },{max:50,message:'最多输入50个字'}] }]" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="8">
          <a-col :span="12">
            <a-form-item label="redirect" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input
                :disabled="!isAdmin"
                autocomplete="off"
                v-decorator="['redirect',{rules:[{ required: false, message: '请输入重定向！' }, {pattern: /^[^\s]*$/, message: '重定向不能包含空格！' },{max:100,message:'最多输入100个字'}] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="path" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input
                :disabled="!isAdmin"
                autocomplete="off"
                v-decorator="['path',{rules:[{ required: false, message: '请输入路径！' }, {pattern: /^[^\s]*$/, message: '路径不能包含空格！' },{max:100,message:'最多输入100个字'}] }]" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="8">
          <a-col :span="12">
            <a-form-item label="target" :label-col="{ span: 8 }" :wrapper-col="{ span: 16}">
              <a-input
                :disabled="!isAdmin"
                autocomplete="off"
                v-decorator="['target',{rules:[{ required: false, message: '请输入目标！' }, {pattern: /^[^\s]*$/, message: '目标不能包含空格！' },{max:100,message:'最多输入100个字'}] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="hiddenHeader" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-radio-group name="radioGroup" :disabled="!isAdmin" :defaultChecked="1" v-decorator="['isHiddenHeaderContent']" >
                <a-radio :value="1">是</a-radio>
                <a-radio :value="0">否</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="8">
          <a-col :span="12">
            <a-form-item label="hidden" :label-col="{ span: 8 }" :wrapper-col="{ span: 16}">
              <a-radio-group name="radioGroup" :disabled="!isAdmin" :defaultChecked="0" v-decorator="['isHidden']">
                <a-radio :value="1">是</a-radio>
                <a-radio :value="0">否</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="keepAlive" :label-col="{ span: 8 }" :wrapper-col="{ span: 16}">
              <a-radio-group name="radioGroup" :disabled="!isAdmin" :defaultChecked="0" v-decorator="['isKeepAlive']">
                <a-radio :value="1">是</a-radio>
                <a-radio :value="0">否</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="8">
          <a-col :span="24">
            <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 20}">
              <a-textarea :disabled="!isAdmin" v-decorator="['remark',{rules:[{ required: false, message: '请输入备注！' }, {pattern: /^[^\s]*$/, message: '备注不能包含空格！' },{max:255,message:'最多输入255个字'}] }]" :rows="4"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item :wrapper-col="{ span: 2, offset: 22 }">
          <a-button type="primary" v-if="(params.formTitle==='新建菜单'&&$auth('menu.add'))||(params.formTitle==='编辑菜单'&&$auth('menu.update'))" html-type="submit" :loading="iconLoading">保存</a-button>
        </a-form-item>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { editMenuInfo, addMenuInfo } from '@/api/menu.js'
export default {
  data () {
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'menuForm' }),
      iconLoading: false,
      visible: true
    }
  },
  props: {
    params: {
      type: Object,
      default: function () {
        return {
          formTitle: ''
        }
      }
    }
  },
  computed: mapGetters([
    'menuList',
    'isAdmin'
  ]),
  watch: {
    menuList () {
      console.log('改变', this.menuList)
      // 如果为空,重置表单
      if (Object.keys(this.menuList).length !== 0) {
        this.form.setFieldsValue({
          pName: this.menuList.pName,
          key: this.menuList.key,
          title: this.menuList.name,
          icon: this.menuList.icon,
          redirect: this.menuList.redirect,
          path: this.menuList.path,
          target: this.menuList.target,
          isHiddenHeaderContent: this.menuList.isHiddenHeaderContent,
          isKeepAlive: this.menuList.isKeepAlive,
          isHidden: this.menuList.isHidden,
          remark: this.menuList.remark
        })
      } else {
        this.form.resetFields()
      }
    },
    btnInfo () {
      // 获取到按钮所在的 menuId
      console.log('按钮改变', this.btnInfo)
      this.visible = true
    }
  },
  methods: {
    // 保存
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.iconLoading = true
          const arg = {
            key: values.key,
            title: values.title,
            icon: values.icon,
            redirect: values.redirect,
            path: values.path,
            target: values.target,
            isHiddenHeaderContent: values.isHiddenHeaderContent,
            isKeepAlive: values.isKeepAlive,
            isHidden: values.isHidden,
            remark: values.remark,
            pid: this.menuList.pid
          }
          if (this.menuList.id != null) {
            arg.id = this.menuList.id
            this.editMenu(arg)
          } else {
            this.addMenu(arg)
          }
        }
      })
    },
    // 编辑菜单
    editMenu (info) {
      editMenuInfo(info).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message, 3)
          this.iconLoading = false
          // 完成提交后,向父组件传递事件
          this.$emit('submitEvent')
        } else {
          this.$message.error(res.info.message, 3)
          this.iconLoading = false
        }
      })
    },
    // 新建菜单
    addMenu (info) {
      addMenuInfo(info).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message, 3)
          this.iconLoading = false
          // 完成提交后,向父组件传递事件
          this.$emit('submitEvent')
          this.menuList.id = res.data
          this.params.formTitle = '编辑菜单'
        } else {
          this.$message.error(res.info.message, 3)
          this.iconLoading = false
        }
      })
    }
  }
}
</script>
<style>
  .formContainer{
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-item:center;
  }
</style>
